import Dexie from 'dexie';

export const db = new Dexie('nexusDatabase');
db.version(1).stores({
	//api_logs: '++id, ts, api, detail',
	api_errors: '++id, ts, api, detail, error_detail',
});
